import React from 'react'
import Modal from 'react-modal'
import ReactTable from 'react-table'

import { getSubModalStyles } from '../../../common/utils'

type Props = {
  isModalOpen: Boolean,
  closeModal: Function,
  history: [[Number]],
  vendorName: String,
}

const VendorHistoryModal = ({ closeModal, history }: Props) => (
  <Modal isOpen={!!history} onRequestClose={closeModal} style={getSubModalStyles()}>
    <div>
      <button onClick={closeModal}>Stäng</button>
      <hr />
      <ReactTable
        data={history || []}
        filterable
        style={{ width: '100%' }}
        columns={(history || []).map((item) => ({
          Header: item.carrierName,
          id: item.carrierName || 'id',
          accessor: (d) => (d.carrierName === item.carrierName ? item.count : ''),
        }))}
        defaultFilterMethod={(filter, row) => String(row[filter.id].toLowerCase()).includes(filter.value.toLowerCase())}
        NoDataComponent={() => null}
        showPagination={true}
        showPageSizeOptions={false}
        loading={!history}
        loadingText="Laddar..."
        pageSize={20}
        className="-striped -highlight"
        sortable={true}
      />
    </div>
  </Modal>
)

export default VendorHistoryModal
